module.exports = __webpack_public_path__ + "static/live-intro1-f085b413c700ed55bd3ba6637937cc8f.jpg";